import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { AnimationWrapper } from './views/animate';
import { Background } from './components/Background';
import { Offers } from './views/Offers';

const LayoutComponent = () => (
	<AnimationWrapper>
		<Background />
		<Offers />
	</AnimationWrapper>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Offers)
	.setTransitionTime(600)
	.build();

export default Layout;
